import { useNavigate, useOutletContext } from 'react-router-dom';
import { Group } from '../../../../types/communication';
import NewGroupDrawer from './NewGroupDrawer';

interface GroupNewOutletContext {
    closeTo: string;
    onGroupCreated?: (group: Group) => void;
}

export default function GroupNewDrawerRoute() {
    const navigate = useNavigate();
    const context = useOutletContext<GroupNewOutletContext>();
    const closeTo = context?.closeTo ?? '..';

    const close = () => navigate(closeTo);

    return (
        <NewGroupDrawer
            open
            onClose={close}
            onCreated={(group) => {
                context?.onGroupCreated?.(group);
            }}
        />
    );
}
